const formatZambiaPhone = (rawNumber) => {
  if (!rawNumber) return '';

  const digitsOnly = String(rawNumber).replace(/\D/g, '');
  let localPart = '';

  if (digitsOnly.startsWith('260')) {
    localPart = digitsOnly.slice(3);
  } else if (digitsOnly.startsWith('0')) {
    localPart = digitsOnly.slice(1);
  } else {
    localPart = digitsOnly;
  }

  if (localPart.length !== 9) {
    return '';
  }

  return `+260${localPart}`;
};

export default {
  name: 'ADMIN_MODULE',
  state: {
    users: [],
    roles: [],

    loading: false,
    error: null
  },
  getters: {
    getUsers: state => state.users,
    getRoles: state => state.roles,
    // isLoading: state => state.loading,
    // getError: state => state.error,
    // getApiKey: state => state.apiKey
  },
  mutations: {
    SET_USERS(state, users) {
      state.users = users;
    },
    SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_ERROR(state) {
      state.error = null;
    }
  },
  actions: {
    async fetchUsers(context) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${pettyCashApi}users/active`;

        const response = await axios.get(url, {
          headers: {
            'X-API-KEY': apiKey
          }
        });

        context.commit('SET_USERS', response.data.users);
        return response.data.users;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to fetch users');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    },

    async createUser(context, userData) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${pettyCashApi}users`;

        const formattedContact = formatZambiaPhone(userData ? userData.contactNumber : '');
        if (!formattedContact) {
          throw new Error('Invalid phone number. Please use +260XXXXXXXXX.');
        }

        const payload = {
          ...userData,
          contactNumber: formattedContact
        };

        const response = await axios.post(url, payload, {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': apiKey
          }
        });

        return response.data;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to create user');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    },

    async updateUser(context, userData) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${pettyCashApi}users/${userData.id}`;

        const payload = { ...userData };
        if (Object.prototype.hasOwnProperty.call(payload, 'contactNumber')) {
          const formattedContact = formatZambiaPhone(payload.contactNumber);
          if (!formattedContact) {
            throw new Error('Invalid phone number. Please use +260XXXXXXXXX.');
          }
          payload.contactNumber = formattedContact;
        }

        const response = await axios.put(url, payload, {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': apiKey
          }
        });

        return response.data;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to update user');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    },

    async updateUserPassword(context, { userId, newPassword }) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${pettyCashApi}users/${userId}/password`;

        const response = await axios.put(url, { password: newPassword }, {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': apiKey
          }
        });

        return response.data;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to update user password');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    },

    async toggleUserActive(context, { userId, active }) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${pettyCashApi}users/${userId}/status`;

        const response = await axios.put(url, { active }, {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': apiKey
          }
        });

        return response.data;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to toggle user active status');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    },

    // fetchAllBranches removed: this action collided with the same-named
    // action in Kazang-module, causing the deposit form's mounted hook to
    // dispatch the action twice and produce two HTTP calls per page load.
    // UserListWithCustomModal dispatches 'fetchAllBranches' which now
    // resolves to the single Kazang-module action.


    // ROLES
    async fetchRoles(context) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${pettyCashApi}roles/active`;

        const response = await axios.get(url, {
          headers: {
            'X-API-KEY': apiKey
          }
        });

        context.commit('SET_ROLES', response.data.roles);
        return response.data.roles;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to fetch roles');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    },

    async createRole(context, roleData) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${pettyCashApi}roles`;

        const payload = {
          name: roleData.name,
          canCreateExpenseRequest: roleData.canCreateExpenseRequest ?? false,
          canApproveExpenseRequest: roleData.canApproveExpenseRequest ?? false,
          canViewReports: roleData.canViewReports ?? false,
          canManageUsers: roleData.canManageUsers ?? false,
          canManageRoles: roleData.canManageRoles ?? false,
          canAccessAllBranches: roleData.canAccessAllBranches ?? false,
          canAutoApproveExpenses: roleData.canAutoApproveExpenses ?? false,
          maxAutoApproveAmount: roleData.maxAutoApproveAmount ?? 0
        };

        const response = await axios.post(url, payload, {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': apiKey
          }
        });

        return response.data;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to create role');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    },

    async updateRole(context, roleData) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${pettyCashApi}roles/${roleData.id}`;

        const response = await axios.put(url, roleData, {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': apiKey,
            'X-USER-ID': context.getters.CurrentUserInfo.id
          }
        });

        return response.data;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to update role');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    },

    async deleteRole(context, roleId) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${pettyCashApi}roles/${roleId}`;

        const response = await axios.delete(url, {
          headers: {
            'X-API-KEY': apiKey
          }
        });

        return response.data;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to delete role');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    },

    async deleteUser(context, userId) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${pettyCashApi}users/${userId}`;

        const response = await axios.delete(url, {
          headers: {
            'X-API-KEY': apiKey
          }
        });

        return response.data;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to delete user');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    },

    // Re-assign a user's role without re-creating the user record.
    // Hits UserController.assignRole (`PUT /users/{id}/role`).
    async assignUserRole(context, { userId, roleId }) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${pettyCashApi}users/${userId}/role`;

        const response = await axios.put(url, { roleId }, {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': apiKey
          }
        });

        return response.data;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to assign role');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    }
  }
};
